import { Box, HStack, Text } from "@chakra-ui/react";
import { NestIcon } from "./NestIcon";
import { PropsWithChildren } from "react";

export const BulletPoint = ({
  children,
  color,
}: PropsWithChildren<{ color?: string }>) => {
  return (
    <HStack gap={8} alignItems="flex-start">
      <Box mt={2}>
        <NestIcon width={40} height={20} color={color} />
      </Box>
      <Text flex={1} fontSize="lg">
        {children}
      </Text>
    </HStack>
  );
};
